 import React from "react";
import clsx from "clsx";
import FeeBuilderErrors from "../FeeBuilderErrors";
import DatePickerInput from "../../DatePickerInput/DatePickerInput";
import PercentageInput from "../../PercentageInput/PercentageInput";
import CurrencyInput from "../../CurrencyInput/CurrencyInput";
import SingleSelect from "../../Selects/SingleSelect";
import Select2MultiSelect from "../../Selects/Select2MultiSelect";
import NumberSpinner from "../../NumberSpinner/NumberSpinner"
import { addDays, subDays } from "date-fns";
import Switch from "../../Switch/Switch"

export default class FeeBuilderGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "general",
      "tab-pane": true,
    });

    // var options = []
    // options = this.props.all_guest_types.map((guest_type) =>  {
    //   return <option key={guest_type.id} value={guest_type.id}>{guest_type.name}</option>
    // })

    return (
      <div className={tabClasses}>
        {this.renderErrors()}
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t("code")}*`}</label>
              <input
                type="text"
                name="code"
                value={this.props.code || ""}
                className={this.renderFieldClasses("code")}
                data-model="Fee"
                data-column="code"
                onChange={this.props.onChange}
              />
              {this.renderFieldErrors("code")}
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t("name")}*`}</label>
              <input
                type="text"
                name="name"
                value={this.props.name || ""}
                className={this.renderFieldClasses("name")}
                data-model="Fee"
                data-column="name"
                onChange={this.props.onChange}
              />
              {this.renderFieldErrors("name")}
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("type")}*</label>
              <select
                name="tax_fee_type_id"
                value={this.props.tax_fee_type_id || ""}
                className={this.renderFieldClasses("tax_fee_type")}
                onChange={this.props.onChange}
              >
                <option value="">{I18n.t("please_select_one")}</option>
                {this.props.all_tax_fee_types.map((tax_fee_type) => {
                  return (
                    <option key={tax_fee_type.id} value={tax_fee_type.id}>
                      {tax_fee_type.name}
                    </option>
                  );
                })}
              </select>
              {this.renderFieldErrors("tax_fee_type")}
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("status")}</label>
              <select
                name="status"
                value={this.props.status || ""}
                className="form-control"
                onChange={this.props.onChange}
              >
                <option value="disabled">{I18n.t("Disabled")}</option>
                <option value="enabled">{I18n.t("enabled")}</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>
                {`${I18n.t("begins")}*`}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("season_start_date_helper_text")}
                ></span>
              </label>
              <DatePickerInput
                classNames={this.renderFieldClasses("start_date")}
                selectedDate={this.props.start_date || ""}
                dateFormat={this.props.date_format}
                onChange={this.onChangeStartDate}
              />
              {this.renderFieldErrors("start_date")}
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>
                {`${I18n.t("ends")}`}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("season_end_date_helper_text")}
                ></span>
              </label>
              <DatePickerInput
                className={this.renderFieldClasses("end_date")}
                selectedDate={this.props.end_date || ""}
                dateFormat={this.props.date_format}
                onChange={this.onChangeEndDate}
              />
            </div>
          </div>
        </div>

        <br />

        <div className="container card">
          <div className="row">
            <div className="col-sm-2">
              <div className="input-group">
                <label>{I18n.t("rate")}</label>
                <PercentageInput
                  className={this.renderFieldClasses("percentage")}
                  mDec={4}
                  onChange={this.props.onChangePercentage}
                  value={
                    this.props.percentage || this.props.percentage === 0
                      ? this.props.percentage
                      : null
                  }
                  data-model="Fee"
                  data-column="percentage"
                  data-type="percentage"
                />
                {this.renderFieldErrors("percentage")}
              </div>
            </div>
            <div className="col-sm-2">
              <div className="row content-center">
                <em className="form-descriptor">{I18n.t("or")}</em>
              </div>
            </div>
            <div className="col-sm-7 card amount-unit-card">
              <div className="row">
                <div className="col-sm-4 amount-unit-wrapper">
                  <div className="form-group">
                    <label>
                      {I18n.t("amount")}{" "}
                      <span
                        className="ss-help help"
                        title={I18n.t("taxes_amount_helper_text")}
                      ></span>
                    </label>
                    <CurrencyInput
                      className={this.renderFieldClasses("amount")}
                      onChange={this.props.onChangeAmount}
                      value={this.props.amount}
                    />
                  </div>
                  {this.renderFieldErrors("amount")}
                </div>
                <div className="col-sm-2">
                  <div className="row content-center">
                    <em className="form-descriptor">{I18n.t("per")}</em>
                  </div>
                </div>
                <div className="col-sm-4 amount-unit-wrapper">
                  <label>
                    {I18n.t("unit")}{" "}
                    <span
                      className="ss-help help"
                      title={I18n.t("taxes_unit_helper_text")}
                    ></span>
                  </label>
                  <div className="form-group">
                    <SingleSelect
                      onChange={this.props.onChangeUnit}
                      options={[
                        { name: "room_per_stay", value: "room_per_stay" },
                        { name: "room_per_day", value: "room_per_day" },
                        { name: "guest_per_stay", value: "guest_per_stay" },
                        { name: "guest_per_day", value: "guest_per_day" },
                      ]}
                      defaultValue={this.props.unit ? this.props.unit : null}
                      hasError={this.renderFieldClasses("tax_fee_unit")}
                    />
                    {this.renderFieldErrors("tax_fee_unit")}
                  </div>
                </div>

              </div>
              {
                this.props.unit == "guest_per_stay" && !this.props.tax || this.props.unit == "guest_per_day" && !this.props.tax
                  ?
                <div className="row">

                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>{I18n.t('guests_included')}</label>
                      <NumberSpinner
                        onChange={this.props.onChange}
                        name='guests_included'
                        min={0}
                        value={this.props.guests_included || ''}
                        hasError={this.renderFieldClasses('guests_included')}  />
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <div className="row content-center">
                      <em className="form-descriptor"></em>
                    </div>
                  </div>
                  {
                    !this.props.tax
                      ?
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label>{I18n.t('calculate_by_guest_type')} <span
                            className="ss-help help"
                            title={I18n.t("calculate_by_guest_type_helper_text")}>
                          </span>
                        </label>
                        <Switch 
                          onText="yes" 
                          offText="no" 
                          onChange={this.props.onChangeCalculateByGuestType} 
                          value={this.props.calculate_by_guest_type} 
                          switchId="calculate_by_guest_type"
                        />
                      </div>
                    </div>
                      : 
                    null
                  }
                
                </div>
                  :
                null
              }
            </div>
          </div>
        </div>
      </div>
    );
  }

  onChangeStartDate(startDate) {
    if (this.props.end_date <= startDate) {
      this.props.onChange({
        target: {
          name: "start_date",
          value: startDate,
        },
      });
      if (this.props.end_date && startDate) {
        this.props.onChange({
          target: {
            name: "end_date",
            value: addDays(startDate, 1),
          },
        });
      }
      // this.setState({
      //   start_date: startDate,
      //   end_date: addDays(startDate, 1)
      // });
    } else {
      this.props.onChange({
        target: {
          name: "start_date",
          value: startDate,
        },
      });
      // this.setState({
      //   start_date: startDate
      // });
    }
  }

  onChange(number){
    this.props.onChange({
      target: {
        name: "guests_included",
        value: number,
      }
    })
  }

  onChangeEndDate(endDate) {
    if (this.props.start_date >= endDate) {
      if (this.props.start_date && endDate) {
        this.props.onChange({
          target: {
            name: "start_date",
            value: subDays(endDate, 1),
          },
        });
      }
      this.props.onChange({
        target: {
          name: "end_date",
          value: endDate,
        },
      });
      // this.setState({
      //   start_date: subDays(endDate, 1),
      //   end_date: endDate
      // });
    } else {
      this.props.onChange({
        target: {
          name: "end_date",
          value: endDate,
        },
      });
      // this.setState({
      //   end_date: endDate
      // });
    }
  }

  renderErrors() {
    
    var errors = FeeBuilderErrors.generalErrors(this.props.errors);
    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1;
        return (
          <li key={idx}>
            <b>&#x2022;</b> {error}
          </li>
        );
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldClasses(field) {
    var classname = "form-control";
    if (
      this.props.errors &&
      Object.keys(this.props.errors).length &&
      this.props.errors[field]
    ) {
      classname = classname + " has-errors";
    }
    return classname;
    // if (noFormControl === true) {
    //   var classname = ''
    // } else {
    //   var classname = 'form-control';
    // }
    // if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
    //   classname = classname + ' has-errors';
    // }
    // return classname;
  }
}
